// const { default: AgoraRTC } = require("agora-rtc-sdk-ng");

const options = {
    // Pass your App ID here.
    appId: '',
    // Set the channel name.
    channel: '',
    // Pass your temp token here.
    token: '',//'006a3d7ab91d0f74db68117947fbc9feb3bIACcIsvQDysrA1+GK1/gSmJeSQFbIVVYN4zYROpU1UyfSz20l0lYpwnrIgD9iikXW+6rYwQAAQBbDatjAgBbDatjAwBbDatjBABbDatj',
    // Set the user ID.
    uid: 0,
    caseID:0
};

const logData = {
    "user_unpublished":[],
    "user_left":[],
    "connection_state_change":[],
    "network_quality":[],
    "exception":[],
    "stream_fallback":[],
};

let userType="user not published";
let canLogFlag = false;
let timeOutInterval = 0;

let channelParameters = {
    // A variable to hold a local audio track.
    localAudioTrack: null,
    // A variable to hold a local video track.
    localVideoTrack: null,
    // A variable to hold a remote audio track.
    remoteAudioTrack: null,
    // A variable to hold a remote video track.
    remoteVideoTrack: null,
    // A variable to hold the remote user id.s
    remoteUid: null,
};
let processor = null;
let virtualBackgroundEnabled = false;
// Create an instance of the Agora Engine
let currentCameraLabel = '';
let flagIsVideoRecordingStarted = false;
let videoBackgroundImageFileName = '';
// Create a VirtualBackgroundExtension instance
const extension = new VirtualBackgroundExtension();
// Register the extension
AgoraRTC.registerExtensions([extension]);

const agoraEngine = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
// Dynamically create a container in the form of a DIV element to play the remote video track.
const remotePlayerContainer = document.createElement("div");
// Dynamically create a container in the form of a DIV element to play the local video track.
const localPlayerContainer = document.createElement('div');
// Specify the ID of the DIV container. You can use the uid of the local user.
localPlayerContainer.id = options.uid;
// Set the textContent property of the local video container to the local user id.
localPlayerContainer.textContent = "Local user " + options.uid;
// Set the local video container size.
localPlayerContainer.style.width = "640px";
localPlayerContainer.style.height = "480px";
localPlayerContainer.style.padding = "15px 5px 5px 5px";
// Set the remote video container size.
// remotePlayerContainer.style.width = "640px";
// remotePlayerContainer.style.height = "480px";
// remotePlayerContainer.style.padding = "15px 5px 5px 5px";

// Listen for the "user-published" event to retrieve a AgoraRTCRemoteUser object.
agoraEngine.on("user-published", async (user, mediaType) => {
    // Subscribe to the remote user when the SDK triggers the "user-published" event.
    await agoraEngine.subscribe(user, mediaType);
    console.log("subscribe success", user);
    sendLogDataToServer({logType:"user-published",user, mediaType,dateTime:new Date().toISOString()});
    // Subscribe and play the remote video in the container If the remote user publishes a video track.
    if (mediaType == "video") {
        // Retrieve the remote video track.
        channelParameters.remoteVideoTrack = user.videoTrack;
        // Retrieve the remote audio track.
        channelParameters.remoteAudioTrack = user.audioTrack;
        // Save the remote user id for reuse.
        channelParameters.remoteUid = user.uid.toString();
        // Specify the ID of the DIV container. You can use the uid of the remote user.
        remotePlayerContainer.id = user.uid.toString();
        channelParameters.remoteUid = user.uid.toString();
        // remotePlayerContainer.textContent = "Remote user " + user.uid.toString();
        // Append the remote container to the page body.
        // document.body.append(remotePlayerContainer);
        const remoteContainer = document.getElementById("remote-container");
        remoteContainer.append(remotePlayerContainer)
        // Play the remote video track.
        channelParameters.remoteVideoTrack.play(remotePlayerContainer);
        // console.error('Error publish', options.uid, options.uid.toString().indexOf("444"));

        if (options.uid.toString().indexOf("444") == 0) {
            userType = 'host';
            console.warn('publish host', options.uid);
            // virtualBackgroundProcessor();
            // setBackgroundBlurring();
            if(videoBackgroundImageFileName){
                setBackgroundImage();
            }
            startActualAgoraCloudRecording();

        } else {
            userType = 'audience';
            console.warn('audience', options.uid);
            // 'agora-video-player-track-video-'+user.uid
        }
        timeOutInterval = setInterval(() => {
            clearInterval(timeOutInterval);
            const getRemoteVideoStreamDiv = document.getElementById('' + user.uid)?.getElementsByTagName('video')[0];//document.getElementById('agora-video-player-track-video-'+user.uid);
            // console.log("Interval--- getRemoteVideoStreamDiv",getRemoteVideoStreamDiv);
            if (getRemoteVideoStreamDiv) {
                setTimeout(() => {
                    getRemoteVideoStreamDiv.style.position = "relative";
                }, 1000);
            }
        }, 1000);
    }
    // Subscribe and play the remote audio track If the remote user publishes the audio track only.
    if (mediaType == "audio") {
        // Get the RemoteAudioTrack object in the AgoraRTCRemoteUser object.
        channelParameters.remoteAudioTrack = user.audioTrack;
        // Play the remote audio track. No need to pass any DOM element.
        channelParameters.remoteAudioTrack.play();
    }
});
// Remove the corresponding view when a remote user unpublishes.
agoraEngine.on("user-unpublished", async (remoteUser, mediaType) => {
    let track = remoteUser.track;
    logData.user_unpublished.push({remoteUser, mediaType,datetime:new Date().toISOString()});
    sendLogDataToServer({logType:"user-unpublished",remoteUser, mediaType,dateTime:new Date().toISOString()});
    console.log(
        "***************stream-removed or unpublished : ",
        remoteUser,
        mediaType,
        track
    );
    // stream.close();
});
// Remove the corresponding view when a remote user leaves the channel.
agoraEngine.on("user-left", async (remoteUser) => {
    logData.user_left.push({remoteUser,datetime:new Date().toISOString()});
    sendLogDataToServer({logType:"user-left",remoteUser,dateTime:new Date().toISOString()});
    console.log("************peer-leave : ", remoteUser, options.uid);
    if (`${remoteUser["uid"]}`.indexOf("444") == 0) {
        displayErrorMessagesInModal(
            "Video Call Closed",
            "Video call terminated by the initiator"
        );
        gohome();
    } else {
        // displayErrorMessagesInModal(
        //     "Video Call Closed",
        //     "Video call is terminated by the <b> RESPONDER </b>."
        // );
        displayCloseMeetingConfirmationModal("Video call is terminated by the <b> RESPONDER </b>.");

    }

    stopLocalStream();

    let stream = remoteUser.track;
    if (stream) {
        console.log('stream', stream);
        const streamId = `${remoteUser.uid}`;
        // track.close();
        // removeVideoDiv(streamId);
    }
});

agoraEngine.on("connection-state-change",async (curState, revState, ConnectionDisconnectedReason)=>{
    logData.connection_state_change.push({curState, revState, ConnectionDisconnectedReason,datetime:new Date().toISOString()});
    sendLogDataToServer({logType:"connection-state-change",curState, revState, ConnectionDisconnectedReason,dateTime:new Date().toISOString()});
console.log("connection-state-change",curState, revState, ConnectionDisconnectedReason);
});
agoraEngine.on("network-quality", async(stats)=>{
    if(stats['uplinkNetworkQuality'] >3 || stats['downlinkNetworkQuality'] >3){
        logData.network_quality.push({stats,datetime:new Date().toISOString()});
        sendLogDataToServer({logType:"network-quality",stats,dateTime:new Date().toISOString()});
        console.log("network quality of the local user",stats);
    }
});
agoraEngine.on("exception", async(event)=>{
    logData.exception.push({event,datetime:new Date().toISOString()});
    sendLogDataToServer({logType:"exception",event,dateTime:new Date().toISOString()});
    console.log("exception",event);
});
//uid: UID, isFallbackOrRecover: "fallback" | "recover"
agoraEngine.on("stream-fallback", async(uid, isFallbackOrRecover)=>{
    logData.stream_fallback.push({uid, isFallbackOrRecover,datetime:new Date().toISOString()});
    sendLogDataToServer({logType:"stream-fallback",uid, isFallbackOrRecover,dateTime:new Date().toISOString()});
    console.log("stream-fallback",uid, isFallbackOrRecover);
});
async function joinChannel() {

    console.log('Join a channel', options);
    if (options.uid.toString().indexOf("444") == 0) {
        userType = 'host';
    } else {
        userType = 'audience';
        console.warn('audience', options.uid);
    }
    // Join a channel.
    await agoraEngine.join(options.appId, options.channel, options.token, options.uid);
    // Create a local audio track from the audio sampled by a microphone.
    channelParameters.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
    // Create a local video track from the video captured by a camera.
    channelParameters.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
    // Append the local video container to the page body.
    // document.body.append(localPlayerContainer);
    // Publish the local audio and video tracks in the channel.
    await agoraEngine.publish([channelParameters.localAudioTrack, channelParameters.localVideoTrack]);
    // Play the local video track.
    // channelParameters.localVideoTrack.play(localPlayerContainer);
    channelParameters.localVideoTrack.play('me');
    currentCameraLabel = channelParameters.localVideoTrack.getTrackLabel();
    setOptimizationMode("balanced");
    console.warn("publish success!");
}
async function startRecording(appId, token, channel, uid,caseID=0) {
    // console.trace('Join a channel,startRecording')
    options.channel = channel;
    options.appId = appId;
    options.uid = uid;
    options.token = token;
    options.caseID = caseID;
   await joinChannel();
}
// Listen to the Leave button click event.
async function leaveCall() {
    // Destroy the local audio and video tracks.
    channelParameters.localAudioTrack.close();
    channelParameters.localVideoTrack.close();
    // Remove the containers you created for the local video and remote video.
    removeVideoDiv(remotePlayerContainer.id);
    removeVideoDiv(localPlayerContainer.id);
    // Leave the channel
    await agoraEngine.leave();
    console.log("You left the channel");
    // Refresh the page for reuse
    window.location.reload();
}

// Remove the video stream from the container.
function removeVideoDiv(elementId) {
    console.log("Removing " + elementId + "Div");
    let Div = document.getElementById(elementId);
    if (Div) {
        Div.remove();
    }
};

function displayCloseMeetingConfirmationModal(msg) {
    let elem = document.getElementsByTagName("app-video-calling")[0];
    console.warn("Element: ", elem);
    let videoCallingClassIns = this.ng.getComponent(elem);
    videoCallingClassIns.closeMeeting(msg, true);
}

function startActualAgoraCloudRecording() {
    // debugger
    // this;
    // window;
    if (flagIsVideoRecordingStarted) return;
    flagIsVideoRecordingStarted = true;
    console.error('startActualAgoraCloudRecording');
    let elem = document.getElementsByTagName("app-video-calling")[0];
    console.warn("Element: ", elem);
    let videoCallingClassIns = this.ng.getComponent(elem);
    videoCallingClassIns.startVideoRecording();
}
//false = Audio Muted.
//true = Audio Unmuted.
function muteUnmuteAudio(isMuteAudio) {
    if (isMuteAudio == false) {
        // Mute the local audio.
        // console.error('muteUnmuteAudio', isMuteAudio, 'Mute the local audio.');
        channelParameters.localAudioTrack.setEnabled(false);
        return true;
    }
    else {
        // Unmute the local audio.
        // console.warn('muteUnmuteAudio', isMuteAudio, 'Unmute the local audio.');
        channelParameters.localAudioTrack.setEnabled(true);
        return false;
    }

}

async function leaveChannel() {
    channelParameters.localVideoTrack.stop();
    channelParameters.localAudioTrack.stop();
    channelParameters.localAudioTrack.close();
    channelParameters.localVideoTrack.close();
    await agoraEngine.leave();
    // location.reload();
    console.log("You left the channel");
    if(window && window?.parent  && window?.parent.closeIFrame)
    window?.parent?.closeIFrame();
}
function gohome() {
    history.deleteUrl(location.origin)
    if (typeof window.home == 'function') { // The rest of the world
        window.home();
    } else if (document.all) { // For IE 
        window.location.href = "about:home";
    } else {
        console.error('gohome not found');
        location.href = `https://www.google.com/_/chrome/newtab`;
    }
}
async function stopLocalStream() {
    sendLogDataToServer(logData);
    // localStream.getVideoTrack().stop();
    channelParameters.localVideoTrack.stop();
    channelParameters.localAudioTrack.stop();
    channelParameters.localVideoTrack.close();
    channelParameters.localAudioTrack.close();

    channelParameters.remoteVideoTrack.stop();
    channelParameters.remoteAudioTrack.stop();
    channelParameters.remoteVideoTrack.close();
    channelParameters.remoteAudioTrack.close();
    await agoraEngine.leave();
}
function SwitchDevice(flag) {
    let DevicesLog = {};
    // After the capture, call getDevices to get device information
    const devices = AgoraRTC.getDevices(info => {
        channelParameters.localVideoTrack.close();
        channelParameters.localAudioTrack.close();
        console.log('get device info!', info);
    });
    return DevicesLog;
}

function switchVideoDevice(id) {
    localStream.getVideoTrack().stop();

    channelParameters.switchDevice("video", id, () => {
        console.log('switch Device Ok');
    }, (err) => { console.log('switchDevice Err', err); })
}

async function switchCameraOnMobile(rearCamera) {
    // channelParameters.localVideoTrack = await AgoraRTC.createCameraVideoTrack(id);
    const config = {
        facingMode: rearCamera ? "environment" : "user"
    };
    channelParameters.localVideoTrack.stop();
    channelParameters.localVideoTrack.close();
    // channelParameters.localAudioTrack.stop();
    // channelParameters.localAudioTrack.close();
    console.log('switchCameraOnMobile rearCamera', rearCamera);
    await agoraEngine.unpublish([ channelParameters.localVideoTrack]);
    setTimeout(async () => {
        channelParameters.localVideoTrack = await AgoraRTC.createCameraVideoTrack(config);
        await agoraEngine.publish([channelParameters.localVideoTrack]);
        channelParameters.localVideoTrack.play('me');
        const streamDiv = document.getElementById("me");
        streamDiv.style.transform = "rotateY(180deg)";

    }, 200);

}
function getCameras() {
    console.warn('localVideoTrack', channelParameters.localVideoTrack);
    console.warn('agoraEngine', agoraEngine);
    AgoraRTC.getCameras(false).then((cameras) => {
        console.log('cameras', cameras);
    }).catch((err) => {
        console.log('cameras', err);

    });
}

function displayErrorMessagesInModal(title, msg) {
    document.getElementById("errormsgModal").style.display = "block";
    document.getElementById("errormodaltitle").innerText = title;
    document.getElementById("errormodalmessage").innerHTML = msg;
}
//Referance 
//https://docs-beta.agora.io/en/video-calling/enable-features/virtual-background?platform=web
async function virtualBackgroundProcessor() {
    console.log('virtualBackgroundProcessor',channelParameters.localVideoTrack);
  if (!processor && channelParameters.localVideoTrack) {
    console.log('virtualBackgroundProcessor1');
    // Create a VirtualBackgroundProcessor instance
    processor = extension.createProcessor();
    try {
      // Initialize the extension and pass in the URL of the Wasm file
      await processor.init("/assets/wasms");
    } catch (e) {
      console.log("Fail to load WASM resource!");
      console.error(r);
      return null;
    }
        // Inject the extension into the video processing pipeline in the SDK
        channelParameters.localVideoTrack.pipe(processor).pipe(channelParameters.localVideoTrack.processorDestination);

  }
  return processor;
}


// Set a solid color as the background
async function setBackgroundColor() {
    if (channelParameters.localVideoTrack) {
      document.getElementById("loader-div1").style.display = "block";
  
      let processor = await virtualBackgroundProcessor();
  
      try {
        processor.setOptions({type: 'color', color: '#00ff00'});
        await processor.enable();
      } finally {
        document.getElementById("loader-div1").style.display = "none";
      }
  
      virtualBackgroundEnabled = true;
    }
  }
  
  // Blur the user's actual background
  async function setBackgroundBlurring() {
    if (channelParameters.localVideoTrack) {
    //   document.getElementById("loading").style.display = "block";
  
      let processor = await virtualBackgroundProcessor();
  
      try {
        processor.setOptions({type: 'blur', blurDegree: 2});
        await processor.enable();
      } finally {
        document.getElementById("loader-div1").style.display = "none";
      }
  
      virtualBackgroundEnabled = true;
    }
  }

  async function setBackgroundImage() {
    if(!videoBackgroundImageFileName){
        return;
    }
    console.log('videoBackgroundImageFileName',videoBackgroundImageFileName)
  // Set an image as the background
      const imgElement = document.createElement('img');
      imgElement.crossOrigin = "Anonymous";
    //   imgElement.setAttribute('crossOrigin', '');
      imgElement.onload = async() => {
        document.getElementById("loader-div1").style.display = "block";
  
        let processor = await virtualBackgroundProcessor();
  
        try {
          processor.setOptions({type: 'img', source: imgElement});
          await processor.enable();
        } finally {
          document.getElementById("loader-div1").style.display = "none";
        }
  
        virtualBackgroundEnabled = true;
      }
    //   imgElement.src = '/assets/images/'+videoBackgroundImageFileName;//'/assets/images/astute-bg-png.png';
      imgElement.src = videoBackgroundImageFileName;//'/assets/images/astute-bg-png.png';
  }
  function setVideoBackgroundImageFileName(name){
    if(name && typeof name =='string'){
     videoBackgroundImageFileName = name;
    }
  }


  addEventListener("load", (event) => {
  
//     axios.get('https://api.github.com/users/anuradha9712')
// .then(response =>{
//     console.log(response.data)
// });
  });


function sendLogDataToServer(data) {
    if(!canLogFlag){
        return;
    }
    const params = {
        userType:userType,
        appId:options.appId,
        channel: options.channel,
        uid: options.uid,
        logDataType:data['logType']?data['logType']:'all data',
        logData:JSON.stringify(data),
        caseID:options.caseID
    };
    axios.post("https://agoranodeapp.azurewebsites.net/logvcalldata", params)
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
}

function setLogIntoDB(flag=true){
canLogFlag = flag;
}
//https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/ilocalvideotrack.html#setoptimizationmode
//mode: "balanced" | "motion" | "detail"
async function setOptimizationMode(mode="balanced") {
  if (mode)
    await channelParameters.localVideoTrack.setOptimizationMode(mode);
}